namespace TabAurous.Inventory {
    export interface LotCreationDetailsForm {
        LedgerName: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        NewProductId: Serenity.StringEditor;
        NewProductCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        NewPieces: Serenity.IntegerEditor;
        NewGrossWeight: Serenity.DecimalEditor;
        NewNetWeight: Serenity.DecimalEditor;
        NewStoneWeight: Serenity.DecimalEditor;
        GenerateLot: ButtonEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        AllotedPieces: Serenity.IntegerEditor;
        AllotedWeight: Serenity.DecimalEditor;
        AllotedNetWeight: Serenity.DecimalEditor;
        BalancePieces: Serenity.IntegerEditor;
        BalanceWeight: Serenity.DecimalEditor;
        BalanceNetWeight: Serenity.DecimalEditor;
        ItemsDetails: LotCreationItemsEditor;
    }

    export class LotCreationDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.LotCreationDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LotCreationDetailsForm.init)  {
                LotCreationDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = CommonSubCategoryLookup;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = ButtonEditor;
                var w7 = LotCreationItemsEditor;

                Q.initFormType(LotCreationDetailsForm, [
                    'LedgerName', w0,
                    'ProductCode', w0,
                    'NewProductId', w0,
                    'NewProductCode', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w3,
                    'BrandId', w1,
                    'SuperTypeId', w1,
                    'CollectionId', w1,
                    'NewPieces', w4,
                    'NewGrossWeight', w5,
                    'NewNetWeight', w5,
                    'NewStoneWeight', w5,
                    'GenerateLot', w6,
                    'Pieces', w4,
                    'Weight', w5,
                    'NetWeight', w5,
                    'AllotedPieces', w4,
                    'AllotedWeight', w5,
                    'AllotedNetWeight', w5,
                    'BalancePieces', w4,
                    'BalanceWeight', w5,
                    'BalanceNetWeight', w5,
                    'ItemsDetails', w7
                ]);
            }
        }
    }
}
